import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { GeneralService } from '../../../services/general/general.service';
import { RegistrationService } from '../../../services/registration/registration.service';
import { District } from '../../../models/district.model';
import { Sectional } from '../../../models/sectional.model';
import { City } from '../../../models/City.model';

@Component({
    selector: 'app-require-church',
    templateUrl: './require-church.component.html',
    styleUrls: ['./require-church.component.scss']
})
export class RequireChurchComponent implements OnInit {

    districts: District[];
    sectionals: Sectional[];
    cities: City[];

    districtSelected: District;

    church: any = {
        name: '',
        city_id: null
    }

    constructor(
        public dialogRef: MatDialogRef<RequireChurchComponent>,
        private registrationService: RegistrationService,
        @Inject(MAT_DIALOG_DATA) public data: {}) { }

    onNoClick(): void {
        this.dialogRef.close(null);
    }

    save() {
        this.dialogRef.close(this.church);
    }

    ngOnInit() {
        this.districts = [];
        this.sectionals = [];
        this.cities = [];

        this.registrationService.getDistricts().subscribe((districts: District[]) => {
            this.districts = districts;
        });
    }

    filterSectionalsByDistrictId(id: number) {
        this.sectionals = [];
        this.church.city_id = null;

        this.registrationService.getDistrictDataById(id)
            .subscribe((data: District) => {
                this.districtSelected = data;
                this.sectionals = data.sectionals;
                this.cities = [];
            })
    }

    filterCitiesBySectionalId(id: number) {
        this.church.city_id = null;

        this.districtSelected.sectionals.forEach((sectional) => {
            if (sectional.id == id) {
                this.cities = sectional.cities;
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/require-church/require-church.component.ts